<template>
  <section class="cart payment">
    <QuotesSlider class="payment__quotes" />
    <router-link :to="{ name: 'shop' }" class="btn btn--tertiary cart__shop-link">
      Back to shop
    </router-link>
    <div class="cart__shop">
      <div class="cart__main">
        <ShoppingCartList />
      </div>
      <div class="cart__aside">
        <PaymentMethodList />
      </div>
    </div>
    <SmallPrints flow-styles />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import QuotesSlider from '@/components/flow/QuotesSlider.vue'
import PaymentMethodList from '@/components/payment/method-list/PaymentMethodList.vue'
import ShoppingCartList from '@/components/cart/ShoppingCartList.vue'
import SmallPrints from '@/components/flow/small-prints/SmallPrints.vue'
import { promoProductBundleUtils } from '@/helpers/mixins'

export default {
  name: 'Payment',
  mixins: [promoProductBundleUtils],
  components: {
    QuotesSlider,
    PaymentMethodList,
    ShoppingCartList,
    SmallPrints,
  },
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
    }),
  },
  created() {
    if (this.promoBundlesOnCart) {
      const error = this.promoProductCheckItems()
      if (error) {
        this.setBundleProductError(error)
      }
    }
  },
  watch: {
    shoppingCart: {
      immediate: true,
      handler(items) {
        if (items.length === 0) {
          this.$router.push({ name: 'shop' })
        }
      },
    },
  },
}
</script>

<style lang="scss">
.payment {
  padding: 0 20px;
  max-width: 1200px;
  @include desktop {
    padding: 0 0 25px 0;
    margin-bottom: 135px;
  }
  .cart {
    &__shop {
      margin: 25px 0 0 0;
    }
    &__main {
      padding: 20px;
      @include mobile {
        padding: 40px;
      }
    }
  }
  &__quotes {
    margin-bottom: 30px;
  }
}
</style>
